import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Badge } from "../ui/badge";
import { TestSubsection } from "./TestSection";
import { Shield, Users, Package, Anchor, Calendar, GitBranch, Server, Trash2 } from "lucide-react";
import * as tests from "./testDefinitions";

export const OperationsSection = ({ testResults }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">Operations</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <TestSubsection
          icon={Shield}
          iconColor="text-blue-600"
          title="Roles"
          tests={tests.rolesTests}
          results={testResults.roles}
        />
        
        <TestSubsection
          icon={Users}
          iconColor="text-green-600"
          title="Team"
          tests={tests.teamTests}
          results={testResults.team}
        />
        
        <TestSubsection
          icon={Package}
          iconColor="text-orange-600"
          title="Assets"
          tests={tests.assetsTests}
          results={testResults.assets}
        />
        
        <TestSubsection
          icon={Anchor}
          iconColor="text-cyan-600"
          title="Services"
          tests={tests.servicesTests}
          results={testResults.services}
        />
        
        <TestSubsection
          icon={Server}
          iconColor="text-teal-600"
          title="Services API (Frontend Load)"
          tests={tests.servicesApiTests}
          results={testResults.servicesApi}
        />
        
        <TestSubsection
          icon={Calendar}
          iconColor="text-purple-600"
          title="Bookings"
          tests={tests.bookingsTests}
          results={testResults.bookings}
        />
        
        <TestSubsection
          icon={Calendar}
          iconColor="text-pink-600"
          title="Custom Bookings"
          tests={tests.customBookingTests}
          results={testResults.customBookings}
        />
        
        <TestSubsection
          icon={Users}
          iconColor="text-violet-600"
          title="Custom Requests (Widget)"
          tests={tests.customRequestTests}
          results={testResults.customRequests}
        />
        
        <TestSubsection
          icon={Trash2}
          iconColor="text-red-600"
          title="Account Deletion (App Store)"
          tests={tests.accountDeletionTests}
          results={testResults.accountDeletion}
        />
        
        <TestSubsection
          icon={GitBranch}
          iconColor="text-indigo-600"
          title="Flows"
          tests={tests.flowsTests}
          results={testResults.flows}
        />
      </CardContent>
    </Card>
  );
};
